import { render, staticRenderFns } from "./RelatedVisit.vue?vue&type=template&id=1136c36a"
import script from "./RelatedVisit.vue?vue&type=script&lang=js"
export * from "./RelatedVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports